var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    rx: 200,
    fill: "white",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2556_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.244 192.195C262.531 192.195 312.988 141.94 312.988 80H87.5C87.5 141.986 138.003 192.195 200.244 192.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.244 206.707C137.957 206.707 87.5 257.459 87.5 320H312.988C312.988 257.407 262.484 206.707 200.244 206.707Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2556_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225.488,
    height: 240,
    fill: "white",
    transform: "translate(87.5 80)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsx);
export default __webpack_public_path__ + "static/media/BSX.ea8b43379ba826d20ee4272f3b2d1d81.svg";
export { ForwardRef as ReactComponent };